export const getSessionIdEndpoint = () =>
    `/api/Session`;

export const deleteSessionIdEndpoint = () =>
    `/api/Session`;
